import { useLocalObservable } from 'mobx-react';
import React, { createContext, ReactNode } from 'react';
import { DoctorApi, PatientsApi } from '../../api-client';
import { AuthContext } from '../Auth/auth.provider';
import useStore from '../../helpers/useStore';
import { createApiConfig } from '../../api/createApiConfig';
import DoctorStore from './doctorStore';


interface DoctorProviderProps {
  children: ReactNode;
}

export const DoctorContext = createContext<DoctorStore | null>(null);
DoctorContext.displayName = 'DoctorContext';

export const DoctorProvider = ({ children }: DoctorProviderProps) => {
const AuthenticationStore = useStore(AuthContext);

  const apiClient = new DoctorApi(createApiConfig());

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = useLocalObservable(
    () => new DoctorStore(apiClient,AuthenticationStore)
  );

  store.apiClient = apiClient;

  return (
    <DoctorContext.Provider value={store}>
      {children}
    </DoctorContext.Provider>
  );
};